export const getInitials = (name) => {
  if (!name) {
    return "";
  }
  return name
    .split(" ")
    .map((word) => (word && word.length > 0 ? word[0] : ""))
    .reduce((accumulator, currentValue) => accumulator + currentValue, "");
};

export const extractNameFromEmail = (name) => {
  if (!name) {
    return "";
  }
  return name.split("@").filter(s => !!s)[0]
};
